import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Depop'
        title='Depop Bundles: Multiple sales for you, lower shipping for buyers'
      >
        <p>
          We don't know about you, but we think "bundle" is one of those words that sounds inherently good and exciting.
          "Bundle of joy" may be the top of mind, but that's a bit irrelevant to our topic, so we're going with "bundle
          of cash," which is what you'll end up with regularly if you know how to make a bundle work for you as a
          seller.{' '}
        </p>
        <p>
          On Depop, a "bundle" refers to a single transaction made by a buyer from the same store involving two or more
          items with or without free or discounted shipping. Though bundling isn't unique to Depop, since online
          marketplaces such as Poshmark also offer it, many sellers consider the process more straightforward on this
          platform than the others.
        </p>
        <p>
          As a seller, it would help to state in your bio and even for certain listings that you are open to bundles and
          that interested buyers should get in touch with you directly. It is up to you if you'd like to be upfront and
          include "free shipping on bundles" or only mention that when you're directly in contact with a sure buyer and
          have it already set up at checkout (To activate the bundle discount, toggle ON under shop settings).
        </p>
        <p>
          Depop sellers are not obliged to offer free or discounted shipping when buyers choose to purchase more than
          one item – but there is little to no point if you don't do so. Bundles should be a win-win for both the seller
          and the buyer, which should have an element of bargain somewhere. The seller gets to move her inventory
          faster, while the buyer enjoys a cut back on shipping provided the items are checked out all at once to the
          same domestic delivery address.
        </p>
        <p>
          Once the buyer has already liked or commented on the items she would like to purchase, you can then make a
          special listing with these items specifically for this buyer. Don't forget to inform the buyer once the
          listing is up and indicate how long you'd hold this listing for her. If the buyer doesn't check out within
          this time frame, say by a couple of hours or the following day depends on you, the offer is forfeited.
        </p>
        <p>
          Some sellers don't make a separate listing for the bundles anymore, as the free or discounted shipping will
          automatically apply upon checking out multiple items anyway. They also prefer it this way so that the items
          will be individually marked as "sold" in the listings. If you decide to go with this route, sending a short
          and sweet thank you message to your buyer won't hurt. Adding a layer of actual human interaction to the
          transaction would positively impact your buyer and might even motivate her to make repeat purchases!
        </p>

        <h3>How do the shipping and PayPal earnings work in bundles?</h3>
        <p>
          If you're offering free shipping using USPS, Depop will provide the appropriate shipping label based on the
          sizes of the items in a bundle. These will be covered by one prepaid label only, and the cost of this will
          reflect your total fees. There is also the option to ship the bundle yourself or combine both. For your peace
          of mind and the convenience of you and your buyers, though, it's always better to use the Depop-provided label
          – unless you are truly comfortable and confident handling the shipping aspect yourself.
        </p>
        <p>
          An important note when offering free shipping: Your pricing should cover the shipping you'd be absorbing if
          the item is purchased as part of a bundle. You could follow a rule of thumb to add $2 - S4 more to the price.
          You don't have to sneak in the entire shipping cost to this one item because it will be shared by the rest of
          the items under the same bundle, if ever. Make sure to consider this when pricing your items before posting
          your listings. You cannot raise it only when a buyer expresses interest in purchasing a bundle. Find that
          sweet spot for pricing – one that allows you to profit from the sales even with the free shipping, but at the
          same time, doesn't come off as excessive that any buyer could see through your ruse.
        </p>
        <p>
          Except for shipping, bundled items are not regarded as bundles but as individual items for Depop and PayPal
          fees. Therefore, expect your PayPal earnings to reflect both the Depop fee and the PayPal fee for each item
          sold.
        </p>

        <h3>Are you ready to bundle?</h3>
        <p>
          Mastering the art of bundling on Depop may take some time as it involves a couple of things to consider. But
          as a reseller entrepreneur, we bet you're already familiar when it comes to juggling tasks to grow your
          business. If you also sell on other platforms like Poshmark and Mercari, you might want to consider a smart
          bot that could manage your cross-listing tasks efficiently. Try OneShop's free 7-day trial today and
          experience the difference it could make to your business.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
